<script lang="ts">
  import { startCase } from "lodash";
  import EventsList from "./EventsList.svelte";
  import type { SharedOrder, Event, WarehouseSummaryType } from "@shared/types/Order";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let order: SharedOrder;
  export let OrderEvent;

  const events: Event[] = [];
  const eventsByPickupLocation: { [key: number]: Event[] } = {};
  const orderWarehouseSummaries: WarehouseSummaryType[] = order.warehouse_summaries;

  if (order.distributor_id === VT_802_SPIRITS_DISTRIBUTOR_ID) {
    orderWarehouseSummaries.forEach(summary => {
      const warehouseKey = summary.warehouse_id;
      const warehouseEvents = [
        ...order.order_events.filter(
          event => event.order_product_id === null && event.action === "order_submitted",
        ),
        ...order.order_events.filter(
          event => event.order_product_id !== null && event.warehouse_id === summary.warehouse_id,
        ),
      ];
      eventsByPickupLocation[warehouseKey] = OrderEvent.filterEvents(
        "retailer",
        warehouseEvents,
        summary.display_state,
        summary.original_total_items,
      );
    });
  } else {
    events.push(...OrderEvent.filterEvents("retailer", order.order_events, order.state));
  }

  $: showEventsByPickupLocation = Object.keys(eventsByPickupLocation).length > 0;
</script>

{#if showEventsByPickupLocation}
  {#each orderWarehouseSummaries as summary}
    <div class="show--md">
      <div class="cart__item-header background-white padding--small align-left">
        <span class="default-body--regular default-subheader--regular--md"
          >{startCase(summary.warehouse_name.toLowerCase())} Events</span
        >
      </div>
    </div>
    <div class="background-white align-left margin-bottom--small order-timeline">
      <div class="grid-col c12-12 padding--small align-left">
        <EventsList events={eventsByPickupLocation[summary.warehouse_id]} />
      </div>
    </div>

    <div class="hide--md">
      <div class="grid-row events-container">
        <div class="grid-col c12-12 c10-12--md c8-12--lg padding--small align-left">
          <EventsList events={eventsByPickupLocation[summary.warehouse_id]} />
        </div>
      </div>
    </div>
  {/each}
{:else}
  <div class="show--md">
    <div class="cart__item-header background-white padding--small align-left">
      <span class="default-body--regular default-subheader--regular--md">Events</span>
    </div>
    <div class="background-white align-left margin-bottom--small order-timeline">
      <div class="grid-col c12-12 padding--small align-left">
        <EventsList {events} />
      </div>
    </div>
  </div>

  <div class="hide--md">
    <div class="grid-row events-container">
      <div class="grid-col c12-12 c10-12--md c8-12--lg padding--small align-left">
        <EventsList {events} />
      </div>
    </div>
  </div>
{/if}
